/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance9000 } from "../../api/axiosInstance";
import { normalizeApiError } from "../../api/apiError";

export const fetchAllClaim = createAsyncThunk(
  "claim/fetchClaimList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance9000.get("/api/branch/claim/report/list");
      return response.data.data;
    } catch (err) {
      return rejectWithValue(normalizeApiError(err, "Gagal memuat daftar klaim."));
    }
  }
);

const allClaimBranchSlice = createSlice({
  name: "allClaimBranch",
  initialState: {
    allClaimBranchs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllClaim.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllClaim.fulfilled, (state, action) => {
        state.loading = false;
        state.allClaimBranchs = action.payload;
      })
      .addCase(fetchAllClaim.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default allClaimBranchSlice.reducer;
